/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Coordinates } from './Coordinates';
import {
    CoordinatesFromJSON,
    CoordinatesFromJSONTyped,
    CoordinatesToJSON,
    CoordinatesToJSONTyped,
} from './Coordinates';

/**
 * 
 * @export
 * @interface GondolaMappedBiggestFlightPointsRedeemed
 */
export interface GondolaMappedBiggestFlightPointsRedeemed {
    /**
     * 
     * @type {string}
     * @memberof GondolaMappedBiggestFlightPointsRedeemed
     */
    flightDepartureIata?: string;
    /**
     * 
     * @type {string}
     * @memberof GondolaMappedBiggestFlightPointsRedeemed
     */
    flightArrivalIata?: string;
    /**
     * 
     * @type {Coordinates}
     * @memberof GondolaMappedBiggestFlightPointsRedeemed
     */
    flightDepartureCoordinates?: Coordinates;
    /**
     * 
     * @type {Coordinates}
     * @memberof GondolaMappedBiggestFlightPointsRedeemed
     */
    flightArrivalCoordinates?: Coordinates;
    /**
     * 
     * @type {number}
     * @memberof GondolaMappedBiggestFlightPointsRedeemed
     */
    points?: number;
}

/**
 * Check if a given object implements the GondolaMappedBiggestFlightPointsRedeemed interface.
 */
export function instanceOfGondolaMappedBiggestFlightPointsRedeemed(value: object): value is GondolaMappedBiggestFlightPointsRedeemed {
    return true;
}

export function GondolaMappedBiggestFlightPointsRedeemedFromJSON(json: any): GondolaMappedBiggestFlightPointsRedeemed {
    return GondolaMappedBiggestFlightPointsRedeemedFromJSONTyped(json, false);
}

export function GondolaMappedBiggestFlightPointsRedeemedFromJSONTyped(json: any, ignoreDiscriminator: boolean): GondolaMappedBiggestFlightPointsRedeemed {
    if (json == null) {
        return json;
    }
    return {
        
        'flightDepartureIata': json['flight_departure_iata'] == null ? undefined : json['flight_departure_iata'],
        'flightArrivalIata': json['flight_arrival_iata'] == null ? undefined : json['flight_arrival_iata'],
        'flightDepartureCoordinates': json['flight_departure_coordinates'] == null ? undefined : CoordinatesFromJSON(json['flight_departure_coordinates']),
        'flightArrivalCoordinates': json['flight_arrival_coordinates'] == null ? undefined : CoordinatesFromJSON(json['flight_arrival_coordinates']),
        'points': json['points'] == null ? undefined : json['points'],
    };
}

export function GondolaMappedBiggestFlightPointsRedeemedToJSON(json: any): GondolaMappedBiggestFlightPointsRedeemed {
    return GondolaMappedBiggestFlightPointsRedeemedToJSONTyped(json, false);
}

export function GondolaMappedBiggestFlightPointsRedeemedToJSONTyped(value?: GondolaMappedBiggestFlightPointsRedeemed | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flight_departure_iata': value['flightDepartureIata'],
        'flight_arrival_iata': value['flightArrivalIata'],
        'flight_departure_coordinates': CoordinatesToJSON(value['flightDepartureCoordinates']),
        'flight_arrival_coordinates': CoordinatesToJSON(value['flightArrivalCoordinates']),
        'points': value['points'],
    };
}

